import { render, staticRenderFns } from "./Iconbar.vue?vue&type=template&id=16bf98a6"
import script from "./Iconbar.vue?vue&type=script&lang=js"
export * from "./Iconbar.vue?vue&type=script&lang=js"
import style0 from "./Iconbar.vue?vue&type=style&index=0&id=16bf98a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports